<template>

    <div class="hit-row">


    <div v-bind:class="get_class()" :key="entryKey" v-if="details">

      <vote_details

      :surveyName="entry.board.name"
      :colors="{}"
      :details="details"
      :settings="{hideCloseBtn: true, hideHeader: false}"
       />


    </div>

    <div class="hit-col-md-6">

      <entryInfo :entry="entry" />

      <div class="hit-list-group" v-if="entry.hint">
        <div class="hit-list-group-item hit-active">
          {{ $tc('message.idea', 2)+' / '+$tc('message.suggestionForImprovement', 2) }}
        </div>
        <div class="hit-list-group-item">
          <div class="hit-form-group hit-text-left">
            <i>{{ entry.hint }}</i>
          </div>
        </div>
      </div>

      <div class="hit-form-group">
        <feedback_admin_comment :entry="entry" :callback="function(ret){ setEntry(entry); }" />
      </div>

      <div class="hit-form-group">
        <feedback_delete :details="{user: entry.user, board:entry.board, ID: entry.ID}" />
      </div>
    </div>

  </div>

</template>

<script>
import entryInfo from '@core/components/content/app/feedback/feedback_entry_info'
import feedback_delete from '@core/components/content/app/feedback/feedback_delete'
import feedback_admin_comment from '@core/components/content/app/feedback/feedback_admin_comment'
import vote_details from '@core/components/votes/parts/details'
import md5 from 'js-md5'

export default{
  components: {entryInfo, feedback_delete, feedback_admin_comment, vote_details},
  props: {entry: Object, settings: Object},

  data(){

    return{
      entryKey: JSON.stringify(this.entry),
      details: false
    }
  },
  methods: {

    setEntry(entry){
      this.entry = entry;
      this.entryKey = JSON.stringify(this.entry);

    },
    getKey() {
      return this.entryKey;
    },
    get_class () {
      // if( this.entry.hint )
      return 'hit-col-md-6'

      return 'hit-col-md-12'
    },

    set_details: function(){
      var userID = this.$store.getters.user.md5_id

      if (typeof this.$route.params !== 'undefined' && typeof this.$route.params.userID !== 'undefined') {
        userID = this.$route.params.userID
      }

      this.$hit_post({url: 'hitclick/votes/get_vote',
        data: {user: userID, board: md5(this.entry.board.ID+''), ID: md5(this.entry.ID+'')},
        callback: function (ret) {
          if (ret.data[0]) {

            if(ret.data[0]){
              this.details = ret.data[1];
              this.details.hint = "";
            }

          }
        }.bind(this)})



    },
  },
  mounted(){

    this.set_details();
  }
}
</script>
